import React from 'react';
import { Typography, makeStyles, Table } from '@material-ui/core';
import {
  reduxForm,
  Field,
  Form,
  InjectedFormProps,
  FieldArray
} from 'redux-form';
import { Button, BoxWrapper } from 'components/Base';
import Fields from 'components/Fields';
import Customer from './Customers/Customer';

const useStyles = makeStyles({
  form: {
    marginTop: '2rem',
    width: '500px',
    borderRadius: '8px'
  },
  fieldWrapper: {
    padding: '0 1rem'
  },
  btnContainer: {
    padding: '1rem',
    marginTop: '2rem',
    width: '100%'
  },
  addClientBtn: {
    width: '100%',
    paddingTop: '6px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'space-between',
    padding: '1rem'
  },
  addClientContainer: {
    width: '100%',
    paddingTop: '24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'space-between'
  },
  addClientInput: {
    width: '38%',
    marginRight: '12px'
  },
  addClient: {
    cursor: 'pointer',
    borderRadius: '5px',
    '& span': {
      fontSize: '0.7rem'
    }
  },
  saveCancelBtn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '24px'
  }
});

interface EditCaseProps {
  setCaseName: Function;
  setEditCaseInfo: Function;
  newCustomer: boolean;
  setNewCustomer: Function;
}

const EditCase = ({
  handleSubmit,
  submitting,
  setEditCaseInfo,
  newCustomer,
  setNewCustomer
}: InjectedFormProps & EditCaseProps) => {
  const classes = useStyles();

  return (
    <BoxWrapper title="Edit case">
      <Form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.fieldWrapper}>
          <Field
            name="name"
            component={Fields.Text}
            label="Case name"
            style={{ width: '50%' }}
          />
          <div className={classes.addClientContainer}>
            <Typography style={{ width: 'max-content' }}>Client(s)</Typography>
          </div>
        </div>
        <Table>
          <FieldArray
            name="customers"
            component={Customer}
            newCustomer={newCustomer}
            setNewCustomer={setNewCustomer}
          />
        </Table>
        <div className={classes.saveCancelBtn}>
          <Button
            key="cancel"
            color="primary"
            onClick={() => setEditCaseInfo(false)}
          >
            Cancel
          </Button>
          <Button key="save and exit" isLoading={submitting} type="submit">
            Save
          </Button>
        </div>
      </Form>
    </BoxWrapper>
  );
};

export default reduxForm({
  form: 'editCase',
  enableReinitialize: true
})(EditCase);
